import { useSyncExternalStore } from 'react';

/** Tailwind `sm` と同一（min-width: 640px） */
const SM_MIN_WIDTH_MEDIA = '(min-width: 640px)';

export function useSmUpViewport(): boolean {
    return useSyncExternalStore(
        (onStoreChange) => {
            if (typeof window === 'undefined') return () => {};
            const mq = window.matchMedia(SM_MIN_WIDTH_MEDIA);
            mq.addEventListener('change', onStoreChange);
            return () => mq.removeEventListener('change', onStoreChange);
        },
        () =>
            typeof window !== 'undefined' ? window.matchMedia(SM_MIN_WIDTH_MEDIA).matches : false,
        () => true,
    );
}
